var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrow2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/32px/Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21.3333 27.6667C21.0679 27.6679 20.8132 27.5622 20.6267 27.3733L9.96 16.7067C9.57006 16.3162 9.57006 15.6838 9.96 15.2933L20.6267 4.62667C21.0207 4.25952 21.6347 4.27036 22.0155 4.65117C22.3963 5.03199 22.4071 5.64599 22.04 6.04L12.08 16L22.04 25.96C22.4299 26.3504 22.4299 26.9829 22.04 27.3733C21.8535 27.5622 21.5988 27.6679 21.3333 27.6667Z",
    fill: "#2E2E2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow2);
export default __webpack_public_path__ + "static/media/icon-arrow2.02649c7796d7f29e7bab7bba048606ab.svg";
export { ForwardRef as ReactComponent };